// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__9l2ER","loading-spin":"Loading_loading-spin__zazuO","loading-dark":"Loading_loading-dark__JstT9"};